import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useLazyGetCasePermissionQuery } from "@/services/caseSummary/caseSummaryReducer";
import { RootState } from "@/app/store";
import { setCasePermission } from "./permission-slice";

export const usePermission = (currentCaseId?: any, doFetch = false) => {
  const dispatch = useDispatch();
  const { caseId } = useParams<{ caseId: string }>();
  const currentCaseData = useSelector((state: RootState) => state.case);
  const thisCaseId = currentCaseId || caseId;

  const [getCasePermission, { data: casePermissionData }] =
    useLazyGetCasePermissionQuery();
  const updateCasePermission = useCallback(
    async (caseId: string) => {
      const casePermissionData = await getCasePermission(caseId).unwrap().then((res)=>res).catch((err)=>err);
      let hasCasePermission = Object.keys(casePermissionData).length > 0;
      let validCaseId =true
      if (!hasCasePermission) {
        validCaseId=true
      }
      else if(casePermissionData?.data?.errors?.caseId){
        if(casePermissionData?.data?.errors?.caseId[0]?.includes("not valid")){
          hasCasePermission=false
          validCaseId=false
        }
      }
      dispatch(
        setCasePermission({
          ...casePermissionData,
          hasCasePermission: hasCasePermission,
          validCaseId:validCaseId,
          checkingPermissions: false,
        })
      );
    },
    [dispatch, getCasePermission]
  );
  useEffect(() => {
    if (doFetch && thisCaseId) {
      updateCasePermission(thisCaseId);
      return;
    }

    if (
      currentCaseData.caseId &&
      doFetch &&
      thisCaseId &&
      thisCaseId !== currentCaseData.caseId
    ) {
      updateCasePermission(thisCaseId);
    }

    return () => {
      // cleanup
    };
  }, [thisCaseId, updateCasePermission, doFetch, currentCaseData]);

  return casePermissionData;
};
